export default "__VITE_ASSET__M3SQv8M1__"